import { useStore } from '@assets/model/Store';
import { getAuth } from 'firebase/auth';
import { HTTPClient } from 'koajax';

export class Backend {
	constructor() {
		console.log('Backend initialized');
	}

	async send_request(url) {
		const store = useStore();
		const fbUser = getAuth().currentUser;
		const token = await fbUser.getIdToken(true);
		var http = new HTTPClient();
		const resp = await http.get(url, { 'Authorization': 'Bearer ' + token });
		console.log(resp);
		return resp;
	}

	async set_job(tickerId: string) {
		const api = `http://localhost:8083/rest/data/add_job/${tickerId}?report=10K`;
		return this.send_request(api);
	}
}